import types from 'actions/types'
import { baseAsyncTypes } from 'actions/types'
import { createDataBlockReducer } from 'helpers/reducer'
import { combineReducers } from 'redux'
import Immutable from 'seamless-immutable'
import detailsTab from './detailsTab'
import documentsTab from './documentsTab'
import newDocumentsTab from './newDocumentsTab'
import opportunitiesTab from './opportunitiesTab'
import quotesTab from './quotesTab'
import invoicesTab from './invoicesTab'
import activitiesTab from './activitiesTab'
import companyContacts from './companyContacts'

const contactId = (state = null, action) => {
  switch (action.type) {
    case types.CONTACTS_DETAILS_CONTACT_LOAD_ATTEMPT: return action.contactId || state
    // We need to null out the contactID if a company has been selected
    case types.CONTACTS_DETAILS_COMPANY_LOAD_ATTEMPT: return null
    default: return state
  }
}

const companyId = (state = null, action) => {
  switch (action.type) {
    case types.CONTACTS_DETAILS_COMPANY_LOAD_ATTEMPT: return action.companyId || state
    case types.CONTACTS_DETAILS_CONTACT_LOAD_SUCCESS: return action.data.companyId || null
    default: return state
  }
}

const currentTab = (state = Immutable('details'), action) => {
  switch (action.type) {
    case types.NAVIGATION_SET_SELECTED_CONTACT_TAB: return action.tab
    default: return state
  }
}

export const isContactDetailsVisible = (state = true, action) => {
  switch (action.type) {
    case types.CONTACTS_TOGGLE_CONTACT_DETAILS_VISIBILITY:
      return !state
    default:
      return state
  }
}

export default combineReducers({
  contactId,
  companyId,
  currentTab,
  isContactDetailsVisible,
  detailsTab,
  activitiesTab,
  documentsTab,
  newDocumentsTab,
  opportunitiesTab,
  quotesTab,
  invoicesTab,
  existingCompanies: createDataBlockReducer(baseAsyncTypes.CONTACTS_LOAD_EXISTING_COMPANIES)(),
  companyContacts,
})
